import React, { Component } from 'react'
import { connect } from 'react-redux'

class PerformingAuthorization extends Component {
    state = {
        topRef: React.createRef()
    }

    renderInteractiveTool() {
        
    }

    renderDocument() {
        return (
            <div className="stepPageContainer">
                <div ref={this.state.topRef}>
                    <span className="stepPageTitle"><b>Performing The Authorization</b></span>
                    <p style={{marginTop: '5vh'}}>Once the authentication is complete and a CAVV and ECI value are retrieved, these values can be sent to Moneris using the transactions Purchase with 3-D Secure – cavvPurchase or Pre-Authorization with 3-D Secure – cavvPreauth.</p>

                    <div style={{ width: '80%',backgroundColor: '#9df0ef', padding: '2px 10px', border: '1px solid #000', borderRadius: '10px' ,marginBottom: '5vh', marginTop: '5vh', marginRight: '2vw'}}>
                        <p style={{ color: '#000'}}><strong>NOTE: </strong> Once 3DS authentication is completed and the crypt_type(ECI) = 5 then the transaction will proceed using the cavv_purchase or cavv_preath. If the crypt type = 6 or 7 then the transaction will proceed using purchase or preauth.</p>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderInteractiveTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci } = state.threeDSTwo.main.config;
    const { loading, cavvPurchaseSuccess, cavvPreAuthSuccess, cavvLookupSuccess } = state.threeDSTwo.main;
    const { mode } = state.common.sideNav;
    const { selection } = state.threeDSTwo.stepsList;
    return { cavvPurchaseSuccess, cavvPreAuthSuccess, cavvLookupSuccess, selectedStep: selection, mode, loading, storeId, apiToken, order_id, pan, expdate, amount, cavv, eci, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {})(PerformingAuthorization)
